import styled from '@emotion/styled';
import { colors, Text } from '@innovationdepartment/proxima-ui';
import type { TaxonomyChangeModalViewProps } from './types';

const ProductsContainer = styled.div`
  border-right: 1px solid ${colors.neutral10};
  width: 200px;
`;

const ProductsListWrapper = styled.div`
  padding: 8px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 500px;
  overflow-y: auto;
`;

const TextWrapper = styled.div<{ divider?: boolean }>`
  cursor: default;
  width: 100%;
  padding-bottom: 4px;

  ${({ divider }) => {
    if (!divider) return '';

    return `
      &:not(:last-child) {
        border-bottom: 1px solid ${colors.neutral10};
        padding-bottom: 4px;
      }
    `;
  }}
`;

const BrandProductsTaxonomyChangeModalProductsToUpdate = (props: TaxonomyChangeModalViewProps) => {
  const { products } = props;

  return (
    <ProductsContainer>
      <Text isTermina={false} variant="h6" color="neutral70">
        Selected products
      </Text>
      <ProductsListWrapper>
        {products.map(product => {
          const hierarchy =
            product.override?.taxonomyClassification ?? product.taxonomyClassification;
          const classification = hierarchy.at(-1);
          return (
            <TextWrapper key={product.productId} divider>
              <Text color="neutral70">
                <strong>{product.title}</strong>
              </Text>
              <TextWrapper>
                <Text variant="body2" color="neutral40">
                  {hierarchy.slice(0, -1).join(' > ')} {' > '}
                </Text>
                <Text variant="body2" color="green40">
                  <strong>{classification}</strong>
                </Text>
              </TextWrapper>
            </TextWrapper>
          );
        })}
      </ProductsListWrapper>
    </ProductsContainer>
  );
};

export default BrandProductsTaxonomyChangeModalProductsToUpdate;
